
import CommonUtils from '@/common-utils';
import 'swiper/css/swiper.css'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class FindPassword extends Vue {
  // 본인인증 페이지
  nextStep() {
    // PC면
    if(this.$isMobile == false) {
      window.open(`${CommonUtils.createStaticUrl(this, 'RealNameForm' )}?nextRouteName=FindPasswordRetype`, "_blank", "width=762, height=800")
      return;
    } 

    this.$router.push({name: 'RealNameForm', params: {nextRouteName: 'FindPasswordRetype'}})
  }
}
